<template>
  <div class="classification-view">
    <b-spinner
      v-if="loading"
      variant="primary"
      class="loading-spinner"
    ></b-spinner>
    <div v-else>
      <b-row class="mb-4">
        <b-col cols="12">
          <h4>
            <i class="fas fa-cog mr-2"></i>
            Parâmetros de Classificação da {{ company.fantasyName }}
          </h4>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <b-card no-body class="shadow-sm">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="fas fa-file-alt mr-2 text-primary"></i>
                  Gerais
                </h5>
                <b-button
                  v-b-toggle.generalConfig
                  size="sm"
                  variant="outline-secondary"
                  class="toggle-btn"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="generalConfig" visible class="m-0">
              <b-card no-body>
                <b-tabs card pills>
                  <b-tab title="Meio de Recebimento">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.RECEIVING_MEANS"
                      :active="company.classification.receivingMeans.enabled"
                      :portal-enabled="
                        company.classification.receivingMeans.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.receivingMeans.portalFieldLabel
                      "
                    >
                    </classification-items>
                  </b-tab>
                  <b-tab title="Setor">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.INVOLVED_DEPARTMENT"
                      :active="
                        company.classification.involvedDepartment.enabled
                      "
                      :portal-enabled="
                        company.classification.involvedDepartment.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.involvedDepartment
                          .portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Unidade">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.BUSINESS_UNIT"
                      :active="company.classification.businessUnit.enabled"
                      :portal-enabled="
                        company.classification.businessUnit.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.businessUnit.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Empresa do Grupo">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.BUSINESS_GROUP"
                      :active="company.classification.businessGroup.enabled"
                      :portal-enabled="
                        company.classification.businessGroup.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.businessGroup.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Contrato/Projeto">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.RELATED_PROJECT"
                      :active="company.classification.relatedProject.enabled"
                      :portal-enabled="
                        company.classification.relatedProject.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.relatedProject.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <b-card no-body class="shadow-sm">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="fas fa-exclamation-triangle mr-2 text-warning"></i>
                  Denúncias
                </h5>
                <b-button
                  v-b-toggle.complaintConfig
                  size="sm"
                  variant="outline-secondary"
                  class="toggle-btn"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="complaintConfig" visible class="m-0">
              <b-card no-body>
                <b-tabs card pills>
                  <b-tab title="Origem da Comunicação">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.ORIGIN"
                      :active="company.classification.origin.enabled"
                      :portal-enabled="
                        company.classification.origin.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.origin.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Agente Denunciante">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.REPORTING_AGENT"
                      :active="company.classification.reportingAgent.enabled"
                      :portal-enabled="
                        company.classification.reportingAgent.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.reportingAgent.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Classificação/Classe Interna">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.LEVEL"
                      :active="company.classification.level.enabled"
                      :portal-enabled="
                        company.classification.level.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.level.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Natureza da Denúncia">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.NATURE"
                      :active="company.classification.nature.enabled"
                      :portal-enabled="
                        company.classification.nature.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.nature.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Área responsável pelo tratamento">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.RESPONSIBLE_DEPARTMENT"
                      :active="
                        company.classification.responsibleDepartment.enabled
                      "
                      :portal-enabled="
                        company.classification.responsibleDepartment
                          .portalEnabled
                      "
                      :portal-field-label="
                        company.classification.responsibleDepartment
                          .portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Confiança no Canal">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.CHANNEL_CONFIDENCE"
                      :active="company.classification.channelConfidence.enabled"
                      :portal-enabled="
                        company.classification.channelConfidence.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.channelConfidence
                          .portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Encerramento da Denúncia">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.COMPLAINT_CLOSURE"
                      :active="company.classification.complaintClosure.enabled"
                      :always-active="true"
                      :portal-enabled="
                        company.classification.complaintClosure.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.complaintClosure.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <b-card no-body class="shadow-sm">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="fas fa-headset mr-2 text-info"></i>
                  Ouvidoria
                </h5>
                <b-button
                  v-b-toggle.ombudsmanConfig
                  size="sm"
                  variant="outline-secondary"
                  class="toggle-btn"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="ombudsmanConfig" class="m-0">
              <b-card no-body>
                <b-tabs card pills>
                  <b-tab title="Natureza da Comunicação">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.OMBUDSMAN_NATURE"
                      :active="company.classification.ombudsmanNature.enabled"
                      :portal-enabled="
                        company.classification.ombudsmanNature.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.ombudsmanNature.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Serviço Reclamado">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.OMBUDSMAN_SERVICE"
                      :active="company.classification.ombudsmanService.enabled"
                      :portal-enabled="
                        company.classification.ombudsmanService.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.ombudsmanService.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Segmento do Cliente">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.OMBUDSMAN_SEGMENT"
                      :active="company.classification.ombudsmanSegment.enabled"
                      :portal-enabled="
                        company.classification.ombudsmanSegment.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.ombudsmanSegment.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Encerramento da Ouvidoria">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.OMBUDSMAN_CLOSURE"
                      :active="company.classification.ombudsmanClosure.enabled"
                      :always-active="true"
                      :portal-enabled="
                        company.classification.ombudsmanClosure.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.ombudsmanClosure.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <b-card no-body class="shadow-sm">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="fas fa-shield-alt mr-2 text-success"></i>
                  LGPD
                </h5>
                <b-button
                  v-b-toggle.dsarConfig
                  size="sm"
                  variant="outline-secondary"
                  class="toggle-btn"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="dsarConfig" class="m-0">
              <b-card no-body>
                <b-tabs card pills>
                  <b-tab title="Tipo de Requisição">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.DSAR_REQUIREMENT_TYPE"
                      :active="
                        company.classification.dsarRequirementType.enabled
                      "
                      :portal-enabled="
                        company.classification.dsarRequirementType.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.dsarRequirementType
                          .portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                  <b-tab title="Encerramento LGPD">
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.DSAR_CLOSURE"
                      :active="company.classification.dsarClosure.enabled"
                      :always-active="true"
                      :portal-enabled="
                        company.classification.dsarClosure.portalEnabled
                      "
                      :portal-field-label="
                        company.classification.dsarClosure.portalFieldLabel
                      "
                    ></classification-items>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <b-card no-body class="shadow-sm">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="fas fa-sliders-h mr-2 text-secondary"></i>
                  Customizados
                </h5>
                <b-button
                  v-b-toggle.customConfig
                  size="sm"
                  variant="outline-secondary"
                  class="toggle-btn"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="customConfig" class="m-0">
              <b-card no-body>
                <div class="p-3 border-bottom">
                  <b-button v-b-modal.newGroup size="sm" variant="primary">
                    <i class="fas fa-plus mr-1"></i>
                    Novo Indicador
                  </b-button>
                </div>
                <b-tabs card pills v-if="groups.length > 0">
                  <b-tab
                    v-for="group in groups"
                    :key="group._id"
                    :title="group.name"
                  >
                    <classification-items
                      :company="company._id"
                      :type="ClassificationType.CUSTOM"
                      :active="group.enabled"
                      :portal-enabled="group.portalEnabled"
                      :portal-field-label="group.portalFieldLabel"
                      :group="group._id"
                    ></classification-items>
                  </b-tab>
                </b-tabs>
                <div v-else class="p-4 text-center text-muted">
                  <i class="fas fa-info-circle fa-2x mb-2"></i>
                  <p>Nenhum indicador customizado criado ainda.</p>
                  <p class="small">
                    Clique em "Novo" para criar seu primeiro indicador.
                  </p>
                </div>
              </b-card>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="12">
          <b-card no-body class="shadow-sm">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                  <i class="fas fa-robot mr-2 text-primary"></i>
                  Inteligência Artificial
                </h5>
                <b-button
                  v-b-toggle.aiConfig
                  size="sm"
                  variant="outline-secondary"
                  class="toggle-btn"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="aiConfig" class="m-0">
              <b-card-body>
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 class="mb-1">Resumo Anonimizado com IA</h6>
                    <p class="text-muted mb-0 small">
                      Quando habilitado, permite gerar resumos anonimizados das
                      denúncias utilizando Inteligência Artificial. Os resumos
                      removem informações pessoais identificáveis
                      automaticamente.
                    </p>
                  </div>
                  <b-form-checkbox
                    v-model="aiSummaryEnabled"
                    switch
                    size="lg"
                    @change="saveAISettings"
                    :disabled="savingAISettings"
                  >
                  </b-form-checkbox>
                </div>
                <div v-if="savingAISettings" class="mt-2">
                  <b-spinner small variant="primary" class="mr-2"></b-spinner>
                  <span class="text-muted small">Salvando...</span>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>

      <b-modal
        id="newGroup"
        title="Novo Indicador"
        cancel-title="Cancelar"
        ok-title="Criar"
        cancel-variant="outline-secondary"
        ok-variant="primary"
        @close="cancelIndicator"
        @cancel="cancelIndicator"
        @ok="createIndicator"
      >
        <b-form-group
          label="Nome do Indicador"
          label-for="indicator-name"
          description="Digite um nome descritivo para o novo indicador"
        >
          <b-input
            id="indicator-name"
            v-model="indicator.name"
            placeholder="Ex: Indicador Financeiro"
            trim
            required
          ></b-input>
        </b-form-group>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  getCompany,
  getCompanyClassificationGroups,
  createCompanyClassificationGroup,
  updateAISettings,
} from "../../api/company";

import ClassificationItems from "./classification-items";
import ClassificationType from "../../../../backend/models/ClassificationType.ts";
import { mapGetters } from "vuex";

export default {
  name: "ClassificationView",
  components: { ClassificationItems },
  props: {
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      company: {
        classification: {},
      },
      groups: [],
      indicator: {
        name: "",
      },
      ClassificationType,
      aiSummaryEnabled: true,
      savingAISettings: false,
    };
  },
  computed: {
    ...mapGetters(["profile"]),
    selectedCompanyId() {
      return this.id || this.company?._id || this.profile?.company;
    },
  },
  async created() {
    let companyId = this.id;
    if (!companyId) {
      companyId = this.profile.company;
    }
    const response = await getCompany(companyId);
    const groups = await getCompanyClassificationGroups(companyId);
    const company = response.data;
    company.classification = company.classification || {};

    this.company = company;
    this.groups = groups.data;

    // Carregar configuração de IA
    this.aiSummaryEnabled =
      company.modules?.complaint?.aiSummaryEnabled !== false;

    this.loading = false;
  },
  methods: {
    async saveAISettings() {
      this.savingAISettings = true;
      try {
        await updateAISettings(this.company._id, this.aiSummaryEnabled);
        this.$bvToast.toast(
          this.aiSummaryEnabled
            ? "Resumo com IA habilitado com sucesso!"
            : "Resumo com IA desabilitado com sucesso!",
          {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          }
        );
      } catch (error) {
        console.error("Erro ao salvar configuração de IA:", error);
        // Reverter o toggle em caso de erro
        this.aiSummaryEnabled = !this.aiSummaryEnabled;
        this.$bvToast.toast("Erro ao salvar configuração de IA", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.savingAISettings = false;
      }
    },
    cancelIndicator() {
      this.indicator.name = "";
    },
    async createIndicator() {
      try {
        await createCompanyClassificationGroup(
          this.selectedCompanyId,
          this.indicator.name
        );
        this.$bvToast.toast("Grupo criado com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
        this.indicator.name = "";
        const groups = await getCompanyClassificationGroups(
          this.selectedCompanyId
        );
        this.groups = groups.data;
      } catch (error) {
        console.log(error);
        if (error.response.status === 403) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.classification-view {
  padding: 1rem;
}

.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  border: none;
  transition: all 0.3s ease;
}

.shadow-sm:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.toggle-btn {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-file-input ~ .custom-file-label::after {
  content: "Escolher";
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

::v-deep .card-header {
  background-color: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
  padding: 1rem 1.25rem;
}

::v-deep .nav-pills .nav-link {
  border-radius: 20px;
  margin-right: 0.5rem;
}

::v-deep .card {
  border-radius: 8px;
  overflow: hidden;
  border: 0px solid #e9ecef !important;
}

::v-deep .tab-content {
  border: 0px solid #e9ecef !important;
}
</style>
